module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAKpJREFUOE/VlLENAjEQBHcqIqABvhFCmiAAyiCmED4iIqKhRWfx4m0Z8ZY+sTOfVmPv3tlo5cXKPHUMtL2V9GyIZA/cflq2vZN0l3QuoLEva6EdgctfIJBpbFvSAIzTQbbj4J6An7xOlQakbIp6rRaSr2XbAQthuVqAR+CRAp+AwDALOnV5SVPmt+gMWGlAbYijls1hzfJB0rXhmW2AV03f8W/TYD+Trm75DVESdxWfgEHuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/scene/online_sceneicon.png
// module id = GDxS
// module chunks = 1